import { createActionType } from '@ers/helpers';

const LAZYOPENS = ['File', 'Attachment', 'EditUrl'];
const actions = {
    addLoading: {},
    removeLoading: {}
};
LAZYOPENS.forEach((element) => {
    actions.addLoading[element] = createActionType(`addLoading${element}`)(
        'Lazy'
    );
    actions.removeLoading[element] = createActionType(
        `removeLoading${element}`
    )('Lazy');
});
export default actions;
